import wbsBookingsApi from '../apis/wbsBookingsApi';

const deleteFeatureGroupsService = async (
  featureGroupId: string,
): Promise<void> => {
  await wbsBookingsApi.delete(`/feature-groups/${featureGroupId}`);
};

export default deleteFeatureGroupsService;
